export default __webpack_public_path__ + "static/media/Bezel_Black_Orange.4c43b2ab.png";